import axiosInstance from "../../../utils/axios";
import { URLS } from "../../../utils/constants/urls";

export const getRoles = async () => {
    try {
        const { data } = await axiosInstance.get(URLS.role);
        return data;
    } catch (e) {
        console.error(e)
        // throw e;
    }
};


export const getUserOrg = async () => {
    try {
        const { data } = await axiosInstance.get(URLS.organizationDropdowns);
        return data;
    } catch (e) {
        console.error(e)
        // throw e;
    }
};